module.exports = __webpack_public_path__ + "static/media/9.a3e4ea88.JPG";